const routesToReload = ["transport-view", "assignment-view"]
export const trajectoryOptimizationPageReload = (route: string | null | undefined) => {
    if (!route || !routesToReload.includes(route)) return;

    setTimeout(async () => {
        window.location.reload();
    }, 1000);
}

